import {
  View,
  Text,
  ScrollView,
  TextInput,
  TouchableOpacity,
  ActivityIndicator,
  StyleSheet,
} from "react-native";
import React, { useState } from "react";
import { doc, getDoc, getDocs, collection } from "firebase/firestore";
import { db } from "../firebase";
import Header from "../components/Header";
import { Ionicons } from "@expo/vector-icons";

const promoMatrix = [
  { not: "not" },
  { uno: 30, tres:  0, nueve: 0, dos: 10 },
  { uno: 30, tres: 30, nueve: 0, dos:  0 },
  { uno: 30, tres: 33, nueve: 0, dos: 10 },
  { uno: 25, tres: 25, nueve: 0, dos:  0 },
  { uno: 30, tres: 33, nueve: 0, dos: 10 },
  { uno: 32, tres: 36, nueve: 0, dos:  0 },
  { uno: 32, tres: 34, nueve: 0, dos: 10 },
  { uno: 34, tres: 38, nueve: 0, dos: 20 },
  { uno: 32, tres: 33, nueve: 0, dos: 10 },
  { uno: 34, tres: 34, nueve: 0, dos:  0 },
  { uno: 20, tres: 20, nueve: 0, dos:  0 },
  { uno: 32, tres: 34, nueve: 0, dos:  0 },
  { uno: 32, tres: 30, nueve: 0, dos: 10 },
  { uno: 28, tres: 28, nueve: 0, dos: 10 },
  { uno: 32, tres: 34, nueve: 0, dos:  0 },
  { uno: 30, tres: 33, nueve: 0, dos: 15 },
  { uno: 28, tres: 28, nueve: 0, dos: 10 },
  { uno: 32, tres: 30, nueve: 0, dos:  0 },
  { uno: 40, tres: 30, nueve: 0, dos: 10 },
];

const UNWANTED_TYPE = "2 - K-C / R-C / T";

const AdminClientLookup = ({ navigation }) => {
  const [cuit, setCuit] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const lookup = async () => {
    const clean = cuit.trim().replace("@mail.com", "");
    if (!clean) return;

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const [eroSnap, drnSnap] = await Promise.all([
        getDoc(doc(db, "clientesero", clean)),
        getDoc(doc(db, "clientesdrn", clean)),
      ]);

      const eroData = eroSnap.exists() ? eroSnap.data() : null;
      const drnData = drnSnap.exists() ? drnSnap.data() : null;

      if (!eroData && !drnData) {
        setError("No se encontró ningún cliente con ese CUIT.");
        setLoading(false);
        return;
      }

      // Fetch product list counts
      let eroCount = null;
      let drnCount = null;

      if (eroData?.PRECIOS__ID) {
        try {
          const eroSnap2 = await getDocs(
            collection(db, "erotarifa" + eroData.PRECIOS__ID)
          );
          eroCount = eroSnap2.docs.filter(
            (d) => d.data().TIPO__ID !== UNWANTED_TYPE
          ).length;
        } catch {
          eroCount = "Error al leer";
        }
      }

      if (drnData?.PRECIOS__ID) {
        try {
          const drnSnap2 = await getDocs(
            collection(db, "drntarifa" + drnData.PRECIOS__ID)
          );
          drnCount = drnSnap2.docs.filter(
            (d) => d.data().TIPO__ID !== UNWANTED_TYPE
          ).length;
        } catch {
          drnCount = "Error al leer";
        }
      }

      setResult({ eroData, drnData, eroCount, drnCount });
    } catch (err) {
      setError("Error al consultar la base de datos: " + err.message);
    }

    setLoading(false);
  };

  const getPromoRow = (promoId) => {
    const idx = parseInt(promoId);
    if (!idx || idx < 1 || idx >= promoMatrix.length) return null;
    return promoMatrix[idx];
  };

  return (
    <ScrollView style={s.container} showsVerticalScrollIndicator={false}>
      <Header navigation={navigation} title="Consulta de Cliente" />

      <View style={s.card}>
        <Text style={s.label}>CUIT del cliente</Text>
        <View style={s.inputRow}>
          <TextInput
            style={s.input}
            placeholder="Ej: 20123456789"
            placeholderTextColor="#aaa"
            value={cuit}
            onChangeText={setCuit}
            keyboardType="numeric"
            autoCorrect={false}
            autoCapitalize="none"
            onSubmitEditing={lookup}
          />
          <TouchableOpacity
            style={s.searchBtn}
            onPress={lookup}
            disabled={loading}
          >
            {loading ? (
              <ActivityIndicator color="#fff" size="small" />
            ) : (
              <Ionicons name="search" size={20} color="#fff" />
            )}
          </TouchableOpacity>
        </View>

        {error && (
          <View style={s.errorBox}>
            <Ionicons name="alert-circle" size={18} color="#c0392b" />
            <Text style={s.errorText}>{error}</Text>
          </View>
        )}
      </View>

      {result && (
        <>
          {/* Client Identity */}
          <View style={s.card}>
            <Text style={s.sectionTitle}>Datos del Cliente</Text>
            <InfoRow
              label="Nombre"
              value={
                result.eroData?.APELLIDO ||
                result.drnData?.APELLIDO ||
                "—"
              }
            />
            <InfoRow
              label="CUIT"
              value={result.eroData?.CUIT || result.drnData?.CUIT || cuit}
            />
            <InfoRow
              label="Mail ERO"
              value={result.eroData?.MAIL || "—"}
            />
            <InfoRow
              label="Cód. Cliente DRN"
              value={result.drnData?.COD__CLIENTE || "—"}
            />
          </View>

          {/* ERO */}
          <View style={s.card}>
            <View style={s.brandHeader}>
              <View style={[s.brandDot, { backgroundColor: "#2a2a8e" }]} />
              <Text style={s.sectionTitle}>ERO</Text>
            </View>

            {result.eroData ? (
              <>
                <InfoRow
                  label="Lista de Precios"
                  value={result.eroData.PRECIOS__ID ?? "—"}
                />
                <InfoRow
                  label="Colección Firestore"
                  value={
                    result.eroData.PRECIOS__ID
                      ? "erotarifa" + result.eroData.PRECIOS__ID
                      : "—"
                  }
                  mono
                />
                <InfoRow
                  label="Productos activos"
                  value={result.eroCount ?? "—"}
                />
                <InfoRow
                  label="ID Promo"
                  value={result.eroData.PROMOCION__ID ?? "—"}
                />
                <PromoDetail promoId={result.eroData.PROMOCION__ID} />
              </>
            ) : (
              <Text style={s.missing}>Cliente no encontrado en ERO</Text>
            )}
          </View>

          {/* DRN */}
          <View style={s.card}>
            <View style={s.brandHeader}>
              <View style={[s.brandDot, { backgroundColor: "#e67e22" }]} />
              <Text style={s.sectionTitle}>DRN</Text>
            </View>

            {result.drnData ? (
              <>
                <InfoRow
                  label="Lista de Precios"
                  value={result.drnData.PRECIOS__ID ?? "—"}
                />
                <InfoRow
                  label="Colección Firestore"
                  value={
                    result.drnData.PRECIOS__ID
                      ? "drntarifa" + result.drnData.PRECIOS__ID
                      : "—"
                  }
                  mono
                />
                <InfoRow
                  label="Productos activos"
                  value={result.drnCount ?? "—"}
                />
                <InfoRow
                  label="ID Promo"
                  value={result.drnData.PROMOCION__ID ?? "—"}
                />
                <PromoDetail promoId={result.drnData.PROMOCION__ID} />
              </>
            ) : (
              <Text style={s.missing}>Cliente no encontrado en DRN</Text>
            )}
          </View>
        </>
      )}

      <View style={{ height: 60 }} />
    </ScrollView>
  );
};

const PromoDetail = ({ promoId }) => {
  const idx = parseInt(promoId);
  if (!promoId || isNaN(idx) || idx < 1 || idx >= promoMatrix.length) {
    return (
      <Text style={s.missing}>
        {promoId ? `Promo ${promoId}: sin datos en la matriz` : "Sin promo asignada"}
      </Text>
    );
  }
  const row = promoMatrix[idx];
  return (
    <View style={s.promoBox}>
      <Text style={s.promoTitle}>Descuentos (Promo {idx})</Text>
      <View style={s.promoGrid}>
        <PromoCell label="Tipo 1 (uno)" value={row.uno} />
        <PromoCell label="Tipo 3 (tres)" value={row.tres} />
        <PromoCell label="Tipo 2 (dos)" value={row.dos} />
        <PromoCell label="Otros (nueve)" value={row.nueve} />
      </View>
    </View>
  );
};

const PromoCell = ({ label, value }) => (
  <View style={s.promoCell}>
    <Text style={s.promoCellLabel}>{label}</Text>
    <Text style={s.promoCellValue}>{value}%</Text>
  </View>
);

const InfoRow = ({ label, value, mono }) => (
  <View style={s.infoRow}>
    <Text style={s.infoLabel}>{label}</Text>
    <Text style={[s.infoValue, mono && s.mono]}>{String(value)}</Text>
  </View>
);

export default AdminClientLookup;

const s = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F4F6FD",
  },
  card: {
    margin: 16,
    marginBottom: 0,
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  label: {
    fontSize: 14,
    color: "#555",
    marginBottom: 8,
    fontWeight: "600",
  },
  inputRow: {
    flexDirection: "row",
    gap: 10,
  },
  input: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 8,
    paddingHorizontal: 14,
    paddingVertical: 10,
    fontSize: 16,
    color: "#333",
    backgroundColor: "#F4F6FD",
  },
  searchBtn: {
    backgroundColor: "#2a2a8e",
    borderRadius: 8,
    paddingHorizontal: 16,
    justifyContent: "center",
    alignItems: "center",
  },
  errorBox: {
    marginTop: 12,
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    backgroundColor: "#fdecea",
    borderRadius: 8,
    padding: 10,
  },
  errorText: {
    color: "#c0392b",
    flex: 1,
    fontSize: 14,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#2a2a8e",
    marginBottom: 12,
  },
  brandHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginBottom: 12,
  },
  brandDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
  },
  infoRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: "#f0f0f0",
  },
  infoLabel: {
    fontSize: 14,
    color: "#777",
    flex: 1,
  },
  infoValue: {
    fontSize: 14,
    color: "#333",
    fontWeight: "600",
    flex: 2,
    textAlign: "right",
  },
  mono: {
    fontFamily: "monospace",
    fontSize: 12,
  },
  missing: {
    fontSize: 13,
    color: "#aaa",
    fontStyle: "italic",
    marginTop: 4,
  },
  promoBox: {
    marginTop: 12,
    backgroundColor: "#f0f4ff",
    borderRadius: 8,
    padding: 12,
  },
  promoTitle: {
    fontSize: 13,
    fontWeight: "bold",
    color: "#2a2a8e",
    marginBottom: 10,
  },
  promoGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  promoCell: {
    flex: 1,
    minWidth: "45%",
    backgroundColor: "#fff",
    borderRadius: 6,
    padding: 8,
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#dce4ff",
  },
  promoCellLabel: {
    fontSize: 11,
    color: "#777",
    marginBottom: 4,
  },
  promoCellValue: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#2a2a8e",
  },
});
